import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping } from '@fortawesome/free-solid-svg-icons';

import Button from './Button';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '0.25rem',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const ZipModal = ({
  buttonText,
  show,
  setShow,
  zips,
}) => {
  const handleOpen = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="primary"
      >
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon icon={faBagShopping} className="w-4 h-4 pr-2" />
          {buttonText}
        </div>
      </Button>
      <Modal
        hideBackdrop
        open={show}
        onClose={handleClose}
      >
        <Box sx={{ ...style, width: 300 }}>
          <div>{zips}</div>
          <Button onClick={handleClose}>Close</Button>
        </Box>
      </Modal>
    </>
  );
};

export default ZipModal;
